import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/honex/Footer";

export default function LegalLayout({ title, subtitle, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-zinc-900 flex flex-col">
      {/* Mini header */}
      <header className="bg-zinc-950 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="flex items-center gap-3 group"
          >
            <img
              src="/assets/honex-mark-white.svg"
              alt="Honex GmbH"
              className="h-10 md:h-12 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-zinc-300 hover:text-red-500 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Zur Startseite
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <section className="bg-zinc-950 text-white pb-20 pt-12">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-red-500" />
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-red-500">
                Rechtliches
              </span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter leading-[0.95]">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-4 text-zinc-400 font-light max-w-2xl">{subtitle}</p>
            )}
          </div>
        </section>

        <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 prose-honex">
          {children}
        </article>
      </main>

      <Footer />
    </div>
  );
}
